import { Stack, StackProps, styled, useMediaQuery, useTheme } from "@mui/material";
import { closeTransition, drawerClosedWidth, drawerWidth, HeaderPad, minDrawerThreshold, openTransition } from ".";
import { Outlet } from "react-router";

/////// NO TOCAR ESTO {
const MainContainer = (props: StackProps) => <Stack {...props} component={"main"} sx={{ minHeight: "100vh" }}>{props.children}</Stack>

const DrawerMainContainer = styled(MainContainer, { 
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'smallScreen' 
})<{ open?: boolean, smallScreen?:boolean }>(
    ({ theme }) => ({
        transition: closeTransition(theme),
        variants: [
            {
                props: ({ smallScreen, open }) => !smallScreen && !open,
                style:{
                    marginLeft: `${drawerClosedWidth}px`,
                }
            },
            {
                props: ({ smallScreen, open }) => !smallScreen && open,
                style: {
                    transition: openTransition(theme),
                    marginLeft: `${drawerWidth}px`,
                },
            },
        ],
    })
);

interface ContentProps {
    open: boolean
}

export default function McpBody({
    open
}: ContentProps) {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down(minDrawerThreshold))

    return <DrawerMainContainer open={open} smallScreen={smallScreen}>
        <HeaderPad />
        <Outlet />
    </DrawerMainContainer>
}
/////// }